<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>

            <vue-headful :title="`Publish: ${incident_type.TypeName}  :: MeritEHS`"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light"><i class="fa fa-cogs"></i> Admin</li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/admin/incident-settings`">Incident Settings</router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/admin/incident-types/builder/${incident_type.IncidentTypeId}`">Type Builder</router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        Publish
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-9 col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <template v-if="incident_type.published_at">
                                <div class="alert alert-warning">
                                    This Incident Type has already been published.
                                </div>
                            </template>
                            <template v-else>
                                <div class="alert alert-success">
                                    You are about to publish this Incident Type. Once published, you cannot edit sections and elements. The Incident Type will be locked. You can only add new sections, new fields, and new options to existing option-type fields. You cannot delete, nor edit existing fields.
                                </div>
                                <button class="btn btn-sm btn-success" v-on:click="publishIncidentType()" :disabled="saving">
                                    <span v-if="saving">Publishing...</span>
                                    <span v-else>Publish</span>
                                    Incident Type
                                </button>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            loading: true,
            saving: false,
            IncidentTypeId: this.$route.params.id,
            incident_type: {},
        }
    },

    methods: {
        getIncidentType() {
                //Check for the ID
                if(!this.IncidentTypeId)
                {
                    //Stop here
                    this.loading = false;

                    //Push 1 new section
                    //this.addSection();

                    //Stop here
                    return;
                }

                //Get the data
                this.$http
                    .get('admin/incident-types-edit/' + this.IncidentTypeId)
                    .then(response => {
                        //Set all the data
                        this.incident_type = response.data.incidentType;

                        //Resources
                        //this.injuryTypes = response.data.injuryTypes;
                        //this.hazards = response.data.hazards;
                        //this.behaviors = response.data.behaviors;
                        //this.conditions = response.data.conditions;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            publishIncidentType(){
                //SHow loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('admin/incident-types/publish/' + this.IncidentTypeId)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Incident Type Published');

                    //Return to main list?
                    //this.$router.push('/admin/incident-types');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                    else
                    {
                        //Alert the user
                        this.$toastr.error(error.response.data, 'Failed to Publish Incident Type');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },
    },

    mounted() {
        //Get the inspections
        this.getIncidentType();
    }
}
</script>
